import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="container-soft pt-16 md:pt-24 pb-10">
        <div className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--primary-deep)" }}>Journal</div>
        <h1 className="font-display text-5xl sm:text-6xl mb-6 max-w-3xl" style={{ color: "var(--text-primary)" }}>Reflections on mind, mood, and meaning</h1>
        <p className="max-w-2xl text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          Essays and notes on mental health, self-care, anxiety, relationships, and personal growth.
        </p>
      </section>

      <section className="container-soft pb-24">
        {loading ? (
          <div className="py-20 text-center" style={{ color: "var(--text-secondary)" }}>Loading…</div>
        ) : posts.length === 0 ? (
          <div className="py-20 text-center" style={{ color: "var(--text-secondary)" }}>No posts yet. Check back soon.</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="group rounded-3xl overflow-hidden transition-all hover:-translate-y-1 hover:shadow-md flex flex-col" style={{ background: "var(--surface)", border: "1px solid var(--border-soft)" }} data-testid={`blog-card-${p.slug}`}>
                {p.cover_image && (
                  <img src={p.cover_image} alt={p.title} className="w-full aspect-[16/10] object-cover"/>
                )}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="text-xs uppercase tracking-[0.2em] mb-2" style={{ color: "var(--primary-deep)" }}>{p.category}</div>
                  <h3 className="font-display text-2xl mb-3" style={{ color: "var(--text-primary)" }}>{p.title}</h3>
                  <p className="text-sm leading-relaxed flex-1" style={{ color: "var(--text-secondary)" }}>{p.excerpt}</p>
                  <div className="mt-4 text-sm inline-flex items-center gap-2" style={{ color: "var(--primary-deep)" }}>Read article <ArrowRight size={14}/></div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
